/* eslint-disable max-len */
/* eslint-disable no-undef */
import React from "react";
import { ToastContainer } from "react-toastify";
import MasterService from '../../../../services/MasterService';
import UserService from '../../../../services/UserService';
import ToastService from '../../../../services/ToastService';
import noimageSvg from '../../../../public/noimage.svg';
import uploadicoSvg from '../../../../public/uploadfileico.svg';
import drequipSvg from '../../../../public/stethoscope.svg';
export const userData = localStorage.getItem('persist:root') ?
  JSON.parse(JSON.parse(localStorage.getItem('persist:root')).userData) : '';
import { showLoading, GlobalLoading } from 'react-global-loading';
class EditPractitionerDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedCertiIndex: '',
      selectedCenterIndex: '',
      user: "Practitioner",
      selectedPractionerCountry: 0, selectedCategory: [],
      centerServices: [],
      imageLogoApi: '',
      myImgApi: '',
      userDetails: {},
      type: 'view',
      physicianName: '', centerData: [], certificateData: [],
      selectedRole: '', certificateDesc: '',
      centerAddress: '', username: '', contact: '', pincode: '', selectedCity: '', selectedState: '', centerEmail: '',
      practitionerEmail: '', certificate: [],
      countries: [], categories: [], centerTime: []

    };
  }

  componentDidMount = () => {
    this.state.type === 'view' ? this.getUserDetail(userData.uid) : '';
    this.getAllCountries();
    this.getCategories();
  };

  getUserDetail = (id) => {
    UserService.getUsersDetail(id)
      .then((result) => {
        if (!result) {
          return;
        }
        this.setState({ username: result.data.display_name, consultingFee: result.data?.fee, practitionerEmail: result.data?.user_email, myImgApi: result.data?.user_image, selectedPractionerCountry: result.data.user_country.id, selectedPractitionerCategory: result.data.domain, centerData: result.data.centerData, certificateData: result.data.certificateData });

      }).catch((err) => {

        console.error(err);
      });
  };

  getCategories = () => {
    MasterService.getCategories()
      .then((result) => {
        if (!result) {
          return;
        }
        this.setState({ categories: result });
      })
      .catch((err) => {

        console.error(err);
      });
  };

  getAllCountries = () => {
    MasterService.getAyushCountries().then((result) => {
      if (!result) {
        return;
      }
      this.setState({ countries: result });

    })
      .catch((err) => {
        console.error(err);
      });
  };

  onUserCreation = () => {
    const { selectedPractionerCountry, certificateData, centerData, username, consultingFee, imageLogoApi, myImgApi, user, practitionerEmail } = this.state;
    var centerEmailregex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

    if (selectedPractionerCountry && username && myImgApi && imageLogoApi && practitionerEmail) {
      if (practitionerEmail) {
        if (!centerEmailregex.test(practitionerEmail))
          return ToastService.error("Please enter valid centerEmail");
      }
      showLoading(true);
      var data = new FormData();
      data.append('username', username);
      data.append('consultingFee', consultingFee);
      data.append('role', user.name);
      data.append('user_email', practitionerEmail);
      data.append('logoImg', imageLogoApi);
      data.append('myImg', myImgApi);
      data.append('user_country', selectedPractionerCountry);
      data.append('centerData', centerData);
      data.append('certificateData', certificateData);

      if (this.props.location?.state?.editData) {
        UserService.updateEvent(data).then((result) => {

          result.data.status === 200 ? (
            ToastService.success(result.data.message),
            window.history.back(),
            showLoading(false)) :
            (showLoading(false), ToastService.error(result.data.message));

        });
      }
      else {
        UserService.EditPractitionerDetails(data).then((result) => {

          result.data.status === 200 ? (
            showLoading(false),
            this.props.dismissModal()) :
            (ToastService.error(result.data.message),
              // this.props.dismissModal(),
              showLoading(false));
        });
      }
    }
    else {
      return ToastService.error("Please fill required details");
    }

  };

  onImageSelection = (event) => {
    this.setState({
      imageApi: event.target.files[0]
    });

  };

  deleteImage = () => {
    this.setState({ imageApi: '' });
  };

  toggleStatus = (status, index) => {

    var arr = this.state.centerStatus;
    arr.splice(index, 1, { name: this.state.centerStatus[index].name, status: !status });
    this.setState({ centerStatus: arr });
  };

  handleCategories = (status, catId) => {

    if (status === true) {
      this.setState({
        selectedCategory: [...this.state.selectedCategory, catId]
      });
    }
    else {

      this.setState({ selectedCategory: this.state.selectedCategory.filter((item) => (item !== catId)) });
    }
  };

  onCertificateCreation = () => {
    const { certificateTitle, certificateDesc, certificateApi } = this.state;

    if (certificateTitle, certificateApi) {
      this.setState({
        certificateData: [...this.state.certificateData, { 'certificateTitle': certificateTitle, 'certificateDesc': certificateDesc, 'certificateApi': certificateApi }]
      });
      document.getElementById('closeCertButton').click();
      this.setState({ certificateTitle: '', certificateDesc: '', certificateApi: '' });
      URL.revokeObjectURL(certificateApi);
    }
    else {
      ToastService.error("Please fill required fields");
    }
  };

  onCenterTimeStatus = (index, status) => {
    const centerTime = [...this.state.centerTime];
    const centertimestatus = { ...centerTime[index] };
    centertimestatus.status = status;
    centerTime[index] = centertimestatus;
    this.setState({ centerTime });
  };

  onCenterTimeStart = (index, status) => {
    const centerTime = [...this.state.centerTime];
    const centertimestatus = { ...centerTime[index] };
    centertimestatus.start = status;
    centerTime[index] = centertimestatus;
    this.setState({ centerTime });
  };

  onCenterTimeEnd = (index, status) => {
    const centerTime = [...this.state.centerTime];
    const centertimestatus = { ...centerTime[index] };
    centertimestatus.end = status;
    centerTime[index] = centertimestatus;
    this.setState({ centerTime });
  };

  onCenterServices = (e) => {

    (e.target.value && e.key === "Enter") ?
      this.setState({ centerServices: [...this.state.centerServices, e.target.value], centerService: '' }) : '';
  };

  deleteService = (index) => {
    let arr = this.state.centerServices;
    arr = [...arr.slice(0, index), ...arr.slice(index + 1)];
    this.setState({ centerServices: arr });
  };

  onCertificateSelection = (event) => {
    this.setState({
      certificateApi: event.target.files[0]// [...this.state.certificateApi, event.target.files[0]]
    });

  };

  deleteCertificate() {
    this.setState({ certificateApi: '' });
  }

  onCenterCreation = () => {
    const { physicianName, centerName, selectedCategory, centerServices, centerTime, pincode, contact, centerEmail, centerAddress, selectedCenterCountry } = this.state;
    if (physicianName && centerName && selectedCategory && selectedCenterCountry && centerEmail) {
      var centerEmailregex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
      var mobPattern = new RegExp(/^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/i);

      if (contact) {
        if (!mobPattern.test(contact) || contact.length !== 10)
          return ToastService.error("Please enter valid mobile");
      }
      if (pincode) {
        if (pincode.length !== 6)
          return ToastService.error("Please enter valid pincode");
      }
      if (centerEmail) {
        if (!centerEmailregex.test(centerEmail))
          return ToastService.error("Please enter valid centerEmail");
      }
      this.setState({
        centerData: [...this.state.centerData, { 'physicianName': physicianName, 'centerName': centerName, 'selectedCategory': selectedCategory, 'centerServices': centerServices, 'centerTime': centerTime, 'pincode': pincode, 'contact': contact, 'centerEmail': centerEmail, 'centerAddress': centerAddress, 'selectedCenterCountry': selectedCenterCountry }]
      });
      document.getElementById('closeCenterButton').click();
      this.setState({ 'physicianName': '', 'centerName': '', 'selectedCategory': '', 'centerServices': '', 'centerTime': '', 'pincode': '', 'contact': '', 'centerEmail': '', 'centerAddress': '', 'selectedCenterCountry': '' });
    }
    else {
      ToastService.error("Please fill required fields");
    }
  };

  render() {
    const { countries, selectedCenterCountry, selectedPractionerCountry, centerAddress, username, contact, pincode, selectedCity, selectedState, centerEmail, user, myImgApi, imageLogoApi, centerStatus, centerName, consultingFee, certificateTitle, certificateDesc, certificateApi, categories, centerTime, centerServices, centerService, physicianName, selectedCategory, practitionerEmail, centerData, certificateData, selectedCertiIndex, selectedCenterIndex, type } = this.state;

    return (
      <div className="container pt-2 px-4 m-ver-col">
        <ToastContainer />
        <div className="row mt-2">
          <div className="col-md-1">

          </div>
          <div className="col-md-11 talf">
            {/* <button className="btn-close" aria-label="Close" onClick={() => this.props.dismissModal()} ></button> */}
            <GlobalLoading />
            <div className="head-title">
              <h4 className="prdh">{type === "view" ? "View" : "Add"} {user.name}</h4>
            </div>

            <div className="flhd">
              {/* <p className="marz">Fill the form below to create {user.name} in a country...</p> */}
              {/* <button type="button" className="btn theme-btn-fill"> </button> */}
              {/* <Link to='/edit-practice-data' className="btn theme-btn-fill"> Edit My Details</Link> */}
            </div>
          </div>
        </div>
        <hr className="hrr"></hr>
        <div className="row mt-5">
          <div className="col-md-6">

            <div className="form-group mb-4 position-relative">
              <label htmlFor="eventname" className="form-label over-label">My Name*</label>
              <input disabled={type === 'view'} type="text" className="form-control inpd" placeholder="Enter your name here" name="practitionername" value={username} onChange={(e) => this.setState({ username: e.target.value })} />
            </div>
            <div className="form-group mb-4 position-relative">
              <label htmlFor="clinicname" className="form-label over-label">My Consulting Fee</label>
              <input disabled={type === 'view'} type="number" className="form-control inpd" placeholder="Enter your Consulting Fee" name="consultingFee" value={consultingFee} onChange={(e) => this.setState({ consultingFee: e.target.value })} />
            </div>
            <div className="form-group mb-4 position-relative">
              <label htmlFor="mailid" className="form-label over-label"> {user.name} Email Id*</label>
              <input disabled={type === 'view'} type="email" className="form-control inpd" name="mailid" onChange={(e) => this.setState({ practitionerEmail: e.target.value })} value={practitionerEmail} />
            </div>
            <div className="form-group mb-4 position-relative">
              <label htmlFor="countryname" className="form-label over-label"> {user.name} Country*</label>
              <select name='orderby' className='form-control inppd' aria-label='Shop order' value={selectedPractionerCountry}
                onChange={(e) => this.setState({ selectedPractionerCountry: e.target.value })}>
                <option defaultValue='selected'>Countries*</option>
                {countries.map((item, index) => <option key={index} value={item.id}>{item.blogname}</option>)}
              </select>
            </div>
          </div>
          <div className="col-md-3 m-imgupload">
            <p>My Centre’s Logo*:</p>
            <div className="upload-drag d-flex align-items-center justify-content-center">
              <div className="uploadbox">
                {
                  imageLogoApi ?
                    <><img src={URL.createObjectURL(imageLogoApi)} /> </>
                    :
                    <> <img src={noimageSvg} className="d-block noimg" alt="upload" />
                      <span className="d-block">Upload Image by clicking to upload</span>
                      <input disabled={type === 'view'} className="upload-btn" type="file" accept=".png, .jpg, .jpeg" name="file" onChange={(e) => this.setState({
                        imageLogoApi: e.target.files[0]
                      })} />
                    </>
                }
              </div>
            </div>
          </div>
          <div className="col-md-3 m-imgupload">
            <p>My Image*:</p>
            <div className="upload-drag d-flex align-items-center justify-content-center">
              <div className="uploadbox">
                {
                  myImgApi ?
                    <><img src={URL.createObjectURL(myImgApi)} /> </>
                    :
                    <> <img src={noimageSvg} className="d-block noimg" alt="upload" />
                      <span className="d-block">Upload Image by clicking to upload</span>
                      <input disabled={type === 'view'} className="upload-btn" type="file" accept=".png, .jpg, .jpeg" name="file" onChange={(e) => this.setState({
                        myImgApi: e.target.files[0]
                      })} />
                    </>
                }
              </div>
            </div>

          </div>
        </div>

        <div className="row mt-5 mb-3 ">
          <div className="col-md-10 event-title">
            <h4>My Medical Certifications</h4>
          </div>
          <div className="col-md-2 text-end mb-3 align-middle">
            {type === "view" ? '' : <button type="button" className="btn theme-btn-fill" data-bs-toggle="modal" data-bs-target="#addpractitionercertificate">
              <i className="fa fa-plus-circle" aria-hidden="true" /> Add New
            </button>}
          </div>
          {/* addpractitionercertificate */}
          <hr></hr>
          {certificateData.map((item, index) => <div className="col-md-4 mt-3 " key={index} >
            <div className="card card-ico bg-body-secondary shadow-none" data-bs-toggle="modal" data-bs-target="#viewpractitionercertificate" onClick={() => this.setState({ selectedCertiIndex: index })}>
              <div className="card-body">
                <h5 className="card-title fs-5 fw-bold">{item.certificateTitle}</h5>
                <small>
                  <img src={uploadicoSvg} className="float-end upload-img" alt="upload" />
                  {item.certificateDesc}</small>
                <div className="bdcont">
                  <span className="badge upunap rounded rounded-3 bg-body-tertiary text-dark fw-bold p-2 px-8 mt-2 mb-2"> Uploaded <i className="fa fa-check-circle text-theme fs-5 align-middle" aria-hidden="true"></i></span>

                </div>
              </div>
            </div>
          </div>)}

        </div>

        <div className="row mt-5 mb-3 p-3 border border-secondary-subtle rounded rounded-4">
          <div className="col-md-8 event-title">
            <h4>My Center Of  {user.name === 'Association Users' ? "Association" : "Practice"} </h4>
          </div>
          <div className="col-md-4 text-end mb-3 align-middle">
            {type === 'view' ? '' : <button type="button" className="btn theme-btn-fill" data-bs-toggle="modal" data-bs-target="#newcenter">
              <i className="fa fa-plus-circle" aria-hidden="true" /> Add New Center
            </button>}
          </div>
          <hr></hr>
          {/* editcenter */}
          {centerData?.map((item, index) => <div className="col-md-4 mt-3" key={index}>
            <div data-bs-toggle="modal" data-bs-target="#editcenter" className="card pntr p-3 bg-secondary-subtle center-card">
              <div className="row" onClick={() => this.setState({ selectedCenterIndex: index })}>
                <div className="col-md-2">
                  <img src={drequipSvg} className="mt-4" alt="my centers" />
                </div>
                <div className="col-md-10">
                  <div className="card-body">
                    <h5 className="card-title fs-5 fw-bold">{item.physicianName}
                      {/* <i data-bs-toggle="modal" data-bs-target="#editcenter" className="fa fa-pencil-square-o float-end fw-bold text-dark" aria-hidden="true"></i> */}
                    </h5>
                    <p className="card-text">
                      {item.centerAddress}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>)}
        </div>

        {/* -------------- view document popup ----------------*/}
        <div className="modal fade" id="viewpractitionercertificate" tabIndex="-1" aria-labelledby="certificateapprovalLabel" aria-hidden="true">
          <div className="modal-dialog modal-xl">
            <div className="modal-content bg-white p-3">
              <div className="modal-header">
                <h1 className="modal-title fs-5 w-100" id="certificateapprovalLabel">View my Certification</h1>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => URL.revokeObjectURL(certificateData[selectedCertiIndex]?.certificateApi)}></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-12 p-1 bg-light">

                    <div className="row">
                      <div className="col-md-8 docdesc">
                        <p className="mb-1">Certificate Name*</p>
                        <div className="form-group position-relative">
                          <input disabled={type === 'view'} type="text" className="form-control pd-tb-675em pb-3 docdesc" placeholder="Update the document name here" name="proposeapprove" value={certificateData[selectedCertiIndex]?.certificateTitle}
                          />
                        </div>
                      </div>
                      <div className="col-md-8 docdesc">
                        <p className="mb-1">Certificate Description</p>
                        <div className="form-group position-relative">
                          <input disabled={type === 'view'} type="text" className="form-control pd-tb-675em pb-3 docdesc_in" placeholder="Update the comments here" name="proposeapprove" value={certificateData[selectedCertiIndex]?.certificateDesc}
                          />
                        </div>
                      </div>
                      <div className="col-md-8 docdesc">
                        <p className="mb-1">Certificate Upload*</p>

                        {certificateData[selectedCertiIndex]?.certificateApi && <object
                          aria-labelledby="label12"
                          width="100%"
                          height="100%"
                          type="application/pdf"
                          data={URL.createObjectURL(certificateData[selectedCertiIndex]?.certificateApi)}
                        />}
                        <span>  {certificateData[selectedCertiIndex]?.certificateApi?.name | ''}</span>

                      </div>
                    </div>
                    {/* <div className="cercon_dw mt-3">
                      <button type="button" className="btn rbnn border-2 " data-bs-dismiss="modal" id="closeCertViewButton" >Close</button>
                      <button type="button" className="btn theme-btn-fill border-2"
                        onClick={() => this.onCertificateCreation()} >Add Certificate</button>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* -------------- create new document popup ----------------*/}
        <div className="modal fade" id="addpractitionercertificate" tabIndex="-1" aria-labelledby="certificateapprovalLabel" aria-hidden="true">
          <div className="modal-dialog modal-xl">
            <div className="modal-content bg-white p-3">
              <div className="modal-header">
                <h1 className="modal-title fs-5 w-100" id="certificateapprovalLabel">Add new certification</h1>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => URL.revokeObjectURL(certificateApi)}></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-12 p-1 bg-light">

                    <div className="row">
                      <div className="col-md-8 docdesc">
                        <p className="mb-1">Certificate Name*</p>
                        <div className="form-group position-relative">
                          <input disabled={type === 'view'} type="text" className="form-control pd-tb-675em pb-3 docdesc" placeholder="Update the document name here" name="proposeapprove" value={certificateTitle}
                            onChange={(e) => this.setState({ certificateTitle: e.target.value })} />
                        </div>
                      </div>
                      <div className="col-md-8 docdesc">
                        <p className="mb-1">Certificate Description</p>
                        <div className="form-group position-relative">
                          <input disabled={type === 'view'} type="text" className="form-control pd-tb-675em pb-3 docdesc_in" placeholder="Update the comments here" name="proposeapprove" value={certificateDesc}
                            onChange={(e) => this.setState({ certificateDesc: e.target.value })} />
                        </div>
                      </div>
                      <div className="col-md-8 docdesc">
                        <p className="mb-1">Certificate Upload*</p>
                        {certificateApi ?
                          <> {certificateApi && <object
                            aria-labelledby="label12"
                            width="100%"
                            height="100%"
                            type="application/pdf"
                            data={URL.createObjectURL(certificateApi)}
                          />}
                            <span>  {certificateApi.name}</span>
                          </> :
                          <>  <i className="fa fa-plus fs-3 text-secondary adddocs" aria-hidden="true"></i>

                            <input disabled={type === 'view'} type="file" name="file" accept="application/pdf" onChange={this.onCertificateSelection} />
                            <small className="text-muted pt-3">Upload Certificate in pdf format</small>
                          </>

                        }

                        {certificateApi && <div className="d-block del-btn">
                          <button onClick={() => this.deleteCertificate()}><i className="fa fa-trash" aria-hidden="true"></i></button>
                        </div>}
                      </div>
                    </div>
                    <div className="cercon_dw mt-3">
                      <button type="button" className="btn rbnn border-2 " data-bs-dismiss="modal" id="closeCertButton" onClick={() => URL.revokeObjectURL(certificateApi)}>Close</button>
                      <button type="button" className="btn theme-btn-fill border-2"
                        onClick={() => this.onCertificateCreation()} >Add Certificate</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ------------------- add a center of practice popup ------------------- */}
        <div className="modal fade newcenter" id="newcenter" tabIndex="-1" aria-labelledby="newcenterLabel" aria-hidden="true">
          <div className="modal-dialog modal-xl">
            <div className="modal-content bg-white p-3">
              <div className="modal-header">
                <h1 className="modal-title fs-5 w-100" id="newcenterLabel">Add new center of {user.name === 'Association Users' ? "Association" : "Practice"}</h1>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div className="modal-body">
                <div className="row mt-4">
                  <div className="col-md-6">
                    <div className="form-group mb-4 position-relative">
                      <label htmlFor="practitionername" className="form-label over-label">Head Physician’s Name*</label>
                      <input disabled={type === 'view'} type="text" className="form-control pd-tb-675em" placeholder="Enter your center name Head Physician’s Name" name="practitionername"
                        onChange={(e) => this.setState({ physicianName: e.target.value })} value={physicianName} />
                    </div>
                    <div className="form-group mb-4 position-relative">
                      <label htmlFor="clinicname" className="form-label over-label">Center’s Name*</label>
                      <input disabled={type === 'view'} type="text" className="form-control pd-tb-675em" placeholder="Enter your Center’s Name" name="clinicname" onChange={(e) => this.setState({ centerName: e.target.value })} value={centerName} />
                    </div>

                    <div className="form-group mb-4 position-relative">
                      <label htmlFor="eventname" className="form-label"><b>Domains*:</b></label>
                      <div className="btn-group d-block event-check chbcn" role="group" aria-label="Basic checkbox toggle button group">
                        {categories.map((item, index) => < span key={index}> <input disabled={type === 'view'} type="checkbox" className="btn-check" id={index} autoComplete="off" onClick={(e) => this.handleCategories(e.target.checked, item.name)} checked={selectedCategory.includes(item.name)} />
                          <label className="btn btn-outline-dark " htmlFor={index}>{item.name}</label></span>)}

                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <p className="tab-head">Center’s Timings</p>
                    <table className="table table-striped time-tab">
                      <tbody>
                        {['Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat', 'Sun'].map((item, index) => <tr>
                          <th scope="row">{item}</th>
                          <td> <input disabled={type === 'view'} type="checkbox" name={"centertime" + index} id={"centertime" + index} className="btn-check" autoComplete="off" onChange={(e) => this.onCenterTimeStatus(index, e.target.checked ? 'open' : 'close')} checked={centerTime[index]?.status === 'open' ? true : false} />
                            <label className="btn btn-outline-dark" htmlFor={"centertime" + index}>Open</label>
                          </td>
                          <td>
                            <div className="form-group position-relative">
                              <input disabled={type === 'view'} type='time' className="form-control" data-date-format="HH : MM "
                                value={centerTime[index]?.start} onChange={(e) => this.onCenterTimeStart(index, e.target.value)}
                              />
                            </div>
                          </td>
                          <td><span className="fw-bold">-to-</span></td>
                          <td>
                            <div className="form-group position-relative">
                              <input disabled={type === 'view'} type='time' className="form-control" data-date-format="HH : MM "
                                value={centerTime[index]?.to} onChange={(e) => this.onCenterTimeEnd(index, e.target.value)}
                              />
                            </div>
                          </td>
                        </tr>)}

                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col-md-8">
                    <div className="p-3 bg-primary-subtle brdr">
                      <h5 className="text-dark mb-0">Add Services Provided by the center:</h5>
                      <div className="form-group position-relative">
                        <input disabled={type === 'view'} type="text" className="form-control mt-2 pd-tb-675em" placeholder="Type here to search services" name="searchcenter" value={centerService} onChange={(e) => this.setState({ centerService: e.target.value })} onKeyDown={(e) => this.onCenterServices(e)} />
                      </div>
                    </div>
                    <ul className="list-group search-list mt-3">
                      {centerServices?.map((item, index) => <li key={index} className="list-group-item d-flex justify-content-between align-items-center">{item}
                        <i className="fa fa-window-close fs-4" aria-hidden="true" onClick={() => this.deleteService(index)}></i>
                      </li>)}

                    </ul>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group mb-4 position-relative">
                      <label htmlFor="countryname" className="form-label over-label">Country*</label>
                      <select name='orderby' className='form-control inppd' aria-label='Shop order' value={selectedCenterCountry}
                        onChange={(e) => this.setState({ selectedCenterCountry: e.target.value })}>
                        <option defaultValue='selected'>Countries*</option>
                        {countries.map((item, index) => <option key={index} value={item.id}>{item.blogname}</option>)}
                      </select>
                    </div>
                    <div className="form-group mb-4 position-relative">
                      <label htmlFor="mailid" className="form-label over-label">E-mail Id*</label>
                      <input disabled={type === 'view'} type="email" className="form-control inpd" name="mailid" onChange={(e) => this.setState({ centerEmail: e.target.value })} value={centerEmail} />
                    </div>
                    <div className="form-group mb-4 position-relative">
                      <label htmlFor="statename" className="form-label over-label">State</label>
                      <input disabled={type === 'view'} type="text" className="form-control inpd" name="pincode" onChange={(e) => this.setState({ selectedState: e.target.value })} value={selectedState} />

                    </div>
                    <div className="form-group mb-4 position-relative">
                      <label htmlFor="cityname" className="form-label over-label">City</label>
                      <input disabled={type === 'view'} type="text" className="form-control inpd" name="pincode" onChange={(e) => this.setState({ selectedCity: e.target.value })} value={selectedCity} />
                    </div>
                    <div className="form-group mb-4 position-relative">
                      <label htmlFor="pincode" className="form-label over-label">Pin Code</label>
                      <input disabled={type === 'view'} type="number" className="form-control inpd" name="pincode" onChange={(e) => this.setState({ pincode: e.target.value })} value={pincode} />
                    </div>
                    <div className="form-group mb-4 position-relative">
                      <label htmlFor="centeraddress" className="form-label over-label">Center’s Address</label>
                      <textarea className="form-control textarea-height" name="centeraddress" rows="4" onChange={(e) => this.setState({ centerAddress: e.target.value })} value={centerAddress}></textarea>
                    </div>
                    <div className="form-group mb-4 position-relative">
                      <label htmlFor="contactnumber" className="form-label over-label">Contact Number</label>
                      <input disabled={type === 'view'} type="number" className="form-control inpd" name="contactnumber" onChange={(e) => this.setState({ contact: e.target.value })} value={contact} />
                    </div>

                  </div>
                </div>
              </div><div className="modal-footer">
                <button type="button" className="btn theme-btn-outline" data-bs-dismiss="modal" id="closeCenterButton" >Close</button>
                <button type="button" className="btn theme-btn-fill" onClick={() => this.onCenterCreation()}>Add Center</button>
              </div>
            </div>
          </div>

        </div>
        {/* ------------------- new center popup end ------------------- */}

        {/* ------------------- view a center of practice popup ------------------- */}
        <div className="modal fade newcenter" id="editcenter" tabIndex="-1" aria-labelledby="newcenterLabel" aria-hidden="true">
          <div className="modal-dialog modal-xl">
            <div className="modal-content bg-white p-3">
              <div className="modal-header">
                <h1 className="modal-title fs-5 w-100" id="newcenterLabel">View centwwer of {user.name === 'Association Users' ? "Association" : "Practice"}</h1>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div className="modal-body">
                <div className="row mt-4">
                  <div className="col-md-6">
                    <div className="form-group mb-4 position-relative">
                      <label htmlFor="practitionername" className="form-label over-label">Head Physician’s Name*</label>
                      <input disabled={type === 'view'} type="text" className="form-control pd-tb-675em" placeholder="Enter your center name Head Physician’s Name" name="practitionername"
                        value={centerData[selectedCenterIndex]?.physicianName} />
                    </div>
                    <div className="form-group mb-4 position-relative">
                      <label htmlFor="clinicname" className="form-label over-label">Center’s Name*</label>
                      <input disabled={type === 'view'} type="text" className="form-control pd-tb-675em" placeholder="Enter your Center’s Name" name="clinicname" value={centerData[selectedCenterIndex]?.centerName} />
                    </div>

                    <div className="form-group mb-4 position-relative">
                      <label htmlFor="eventname" className="form-label"><b>Domains*:</b></label>
                      <div className="btn-group d-block event-check chbcn" role="group" aria-label="Basic checkbox toggle button group">
                        {categories.map((item, index) => < span key={index}> <input disabled={type === 'view'} type="checkbox" className="btn-check" id={index} checked={centerData[selectedCenterIndex]?.selectedCategory.includes(item.name)} autoComplete="off" />
                          <label className="btn btn-outline-dark " htmlFor={index}>{item.name}</label></span>)}

                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <p className="tab-head">Center’s Timings</p>
                    <table className="table table-striped time-tab">
                      <tbody>
                        {['Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat', 'Sun'].map((item, index) => <tr>
                          <th scope="row">{item}</th>
                          <td> <input disabled={type === 'view'} type="radio" name={"centertime" + index} id={"centertime" + index} className="btn-check" autoComplete="off" checked={centerTime[index]?.open} />
                            <label className="btn btn-outline-dark" htmlFor={"centertime" + index}>Open</label>
                            <input disabled={type === 'view'} type="radio" name={"centertime" + index} id={"centertime" + index + 1} className="btn-check" autoComplete="off" />
                            <label className="btn btn-outline-dark" htmlFor={"centertime" + index + 1}>Close</label>
                          </td>
                          <td>
                            <div className="form-group position-relative">
                              <input disabled={type === 'view'} type='time' className="form-control" data-date-format="HH : MM "
                                value={centerData[selectedCenterIndex]?.centerTime[index]?.start}
                              />
                            </div>
                          </td>
                          <td><span className="fw-bold">-to-</span></td>
                          <td>
                            <div className="form-group position-relative">
                              <input disabled={type === 'view'} type='time' className="form-control" data-date-format="HH : MM "
                                value={centerData[selectedCenterIndex]?.centerTime[index]?.to}
                              />
                            </div>
                          </td>
                        </tr>)}

                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col-md-8">
                    <div className="p-3 bg-primary-subtle brdr">
                      <h5 className="text-dark mb-0">Add Services Provided by the center:</h5>
                      <div className="form-group position-relative">
                        <input disabled={type === 'view'} type="text" className="form-control mt-2 pd-tb-675em" placeholder="Type here to search services" name="searchcenter" value={centerData[selectedCenterIndex]?.centerService} onChange={(e) => this.setState({ centerService: e.target.value })} onKeyDown={(e) => this.onCenterServices(e)} />
                      </div>
                    </div>
                    <ul className="list-group search-list mt-3">
                      {centerServices.map((item, index) => <li key={index} className="list-group-item d-flex justify-content-between align-items-center">{item}
                        <i className="fa fa-window-close fs-4" aria-hidden="true" onClick={() => this.deleteService(index)}></i>
                      </li>)}

                    </ul>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group mb-4 position-relative">
                      <label htmlFor="countryname" className="form-label over-label">Country*</label>
                      <select name='orderby' className='form-control inppd' aria-label='Shop order' value={centerData[selectedCenterIndex]?.selectedCenterCountry}
                        onChange={(e) => this.setState({ selectedCenterCountry: e.target.value })}>
                        <option defaultValue='selected'>Countries*</option>
                        {countries.map((item, index) => <option key={index} value={item.id}>{item.blogname}</option>)}
                      </select>
                    </div>
                    <div className="form-group mb-4 position-relative">
                      <label htmlFor="statename" className="form-label over-label">State</label>
                      <input disabled={type === 'view'} type="text" className="form-control inpd" name="pincode" onChange={(e) => this.setState({ selectedState: e.target.value })} value={centerData[selectedCenterIndex]?.selectedState} />

                    </div>
                    <div className="form-group mb-4 position-relative">
                      <label htmlFor="cityname" className="form-label over-label">City</label>
                      <input disabled={type === 'view'} type="text" className="form-control inpd" name="pincode" onChange={(e) => this.setState({ selectedCity: e.target.value })} value={centerData[selectedCenterIndex]?.selectedCity} />
                    </div>
                    <div className="form-group mb-4 position-relative">
                      <label htmlFor="pincode" className="form-label over-label">Pin Code</label>
                      <input disabled={type === 'view'} type="number" className="form-control inpd" name="pincode" onChange={(e) => this.setState({ pincode: e.target.value })} value={centerData[selectedCenterIndex]?.pincode} />
                    </div>
                    <div className="form-group mb-4 position-relative">
                      <label htmlFor="centeraddress" className="form-label over-label">Center’s Address</label>
                      <textarea className="form-control textarea-height" name="centeraddress" rows="4" onChange={(e) => this.setState({ centerAddress: e.target.value })} value={centerData[selectedCenterIndex]?.centerAddress}></textarea>
                    </div>
                    <div className="form-group mb-4 position-relative">
                      <label htmlFor="contactnumber" className="form-label over-label">Contact Number</label>
                      <input disabled={type === 'view'} type="number" className="form-control inpd" name="contactnumber" onChange={(e) => this.setState({ contact: e.target.value })} value={centerData[selectedCenterIndex]?.contact} />
                    </div>
                    <div className="form-group mb-4 position-relative">
                      <label htmlFor="mailid" className="form-label over-label">E-mail Id</label>
                      <input disabled={type === 'view'} type="email" className="form-control inpd" name="mailid" onChange={(e) => this.setState({ centerEmail: e.target.value })} value={centerData[selectedCenterIndex]?.centerEmail} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div className="text-end detbottbtn">
          <div className="btninr">
            <button type="button" className="card-link rounded rounded-2 w-100 btntxdsh lightbtn" data-bs-dismiss="modal" id="closeUserButton" onClick={() => this.props.dismissModal()} >Close</button>
            {type === 'create' ? <button type="button" onClick={() => this.setState({ type: 'create' })} className="card-link rounded rounded-2 w-100 btntxdsh darkbtn">Edit</button> : <button type="button" onClick={() => this.onUserCreation()} className="card-link rounded rounded-2 w-100 btntxdsh darkbtn">Save</button>}
          </div>
        </div></div>
      // {/* ------------------- new center popup end ------------------- */ }
    );
  }
}
export default EditPractitionerDetails;